import { css, SerializedStyles } from "@emotion/react";

export function writeVariables(): SerializedStyles {
  return css`
    /* Paramoteur charcoal palette (was navy #001931) */
    --bg-gradient-from: #0a0e12;
    --bg-gradient-to: #0d121a;
    --hover-bg: rgba(255, 255, 255, 0.08);
    --text: #eef2f6;
    --softText: rgba(151, 166, 181, 0.85);
    --overscroll-background: #0a0e12;
    --bg-bottom-sheet: #10171f;

    --edge-padding: 1rem;

    @media (max-width: 360px) {
      --edge-padding: 0.75em;
    }

    --left-safe-area: max(var(--edge-padding), env(safe-area-inset-left));
    --right-safe-area: max(var(--edge-padding), env(safe-area-inset-right));
  `;
}
